import React from "react";
import { motion } from "framer-motion";

import { fadeIn, iceswirlVariants, staggerContainer } from "../variants";
import { aboutData } from "../data";

const About = () => {
  const { title, subtitle, image } = aboutData;
  return (
    <>
      <section className="min-h-[620px]">
        <div className="container mx-auto min-h-[620px]">
          <motion.div
            variant={staggerContainer}
            initial="hidden"
            whileInView={"show"}
            viewport={{ once: false, amount: 0.6 }}
            className="min-h-[620px] flex flex-col items-center lg:flex-row lg:justify-center lg:items-stretch"
          >
            <motion.div
              variants={fadeIn("right", "tween", 0.2, 1.8)}
              className="flex flex-col	justify-center items-center flex-1 text-center lg:text-left"
            >
              <h2 className="text-red-300 h2 capitalize">{title}</h2>
              <p className="text-center mb-8 max-w-[560px]">{subtitle}</p>
            </motion.div>
            <motion.div
              variants={iceswirlVariants}
              className="-mb-[300px] sm:-mr-initial lg:-mr-[186px] z-10"
            >
              <img src={image} alt="" />
            </motion.div>
          </motion.div>
        </div>
      </section>
    </>
  );
};

export default About;
